import { required, email, max } from "vee-validate/dist/rules";
import { $t } from "./i18n";
import { extend } from "vee-validate";

extend("required", {
  ...required,
  message: $t("Das Feld wird benötigt") as string,
});

extend("max", {
  ...max,
  message: $t("Das Feld darf max {length} Zeichen besitzen") as string,
});

extend("email", {
  ...email,
  message: $t("Das Feld muss eine valide E-Mail-Adresse sein") as string,
});
